
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_44326","data-name":"Group 44326","transform":"translate(-67 -36)","fill":"none","stroke":"#262626","stroke-width":"1.5"}},[_c('g',{attrs:{"id":"Rectangle_11661","data-name":"Rectangle 11661","transform":"translate(67 36)"}},[_c('rect',{attrs:{"width":"18","height":"18","rx":"4","stroke":"none"}}),_c('rect',{attrs:{"x":".75","y":".75","width":"16.5","height":"16.5","rx":"3.25"}})]),_c('g',{attrs:{"id":"Group_44160","data-name":"Group 44160","transform":"translate(70 39.5)","stroke-linecap":"round"}},[_c('path',{attrs:{"id":"Path_29932","data-name":"Path 29932","d":"M0 0h.635","transform":"translate(.635 1)"}}),_c('line',{attrs:{"id":"Line_1102","data-name":"Line 1102","x2":"6.865","transform":"translate(4.5 1)"}})])])])
          )
        }
      }
    